import { CheckIcon, CloseIcon, PencilAltIcon, StarIcon } from '@panwds/icons'
import { Tooltip } from '@panwds/react-ui'
import { _T } from '../i18n'
import { stateRef } from '../framework/store'
import NoFavoritesPlaceholder from '../containers/common/NoFavoritesPlaceholder'
import { isNonemptyArray, noop } from '../framework/utils'
import { SPARKY_NAV3_DYNAMIC_BOTTOM_LEFT_EXTPOINT } from '../extpoints'
import { forceRerenderLeftNav, removeFavoritedNavItem } from '../framework/actions'
import EditFavorite from './EditFavorite'
import type { ExtensionsConfig } from '../framework/microAppTypes'

const favBottomNav = {
  point: SPARKY_NAV3_DYNAMIC_BOTTOM_LEFT_EXTPOINT,
  configs: [{
    id: 'sparky.nav.v3.left.bottom.favorites',
    config: {
      key: 'favorites',
      icon: StarIcon,
      title: _T('Favorites'),
      dynamicChildren: () => {
        const favorites = stateRef.current.preferences?.tsgs?.current?.favorites
        if (!isNonemptyArray(favorites)) {
          return []
        }
        const setEditPath = (path: string) => {
          Object.defineProperty(favorites, '_editing_path', { value: path, writable: true })
        }
        return favorites.filter(fav => fav?.path).map((fav, idx) => {
          const isEditing = (favorites as any)._editing_path === fav.path
          const title = isEditing ? <EditFavorite favorite={fav} setEditPath={setEditPath} /> : (
            <Tooltip label={fav.tooltip} defaultPlacement='left-start'>
              <div>{fav.name}</div>
            </Tooltip>
          )
          const config = {
            key: `id:fav-${fav.path}-${idx}`,
            path: isEditing ? '#' : fav.path,
            title: title,
            onClick: isEditing ? noop : undefined,
            actions: isEditing ? [{
              icon: <CheckIcon size={'xs'} />,
              onClick: noop, // will trigger on blur of EditFavorite component
              tooltip: _T('Edit Favorite')
            }] : [
              {
                icon: <PencilAltIcon size={'xs'} />,
                onClick: () => {
                  setEditPath(fav.path)
                  forceRerenderLeftNav()
                },
                tooltip: _T('Done Edit')
              },
              {
                icon: <CloseIcon size={'xs'} />,
                onClick: () => {
                  removeFavoritedNavItem(fav.path)
                  forceRerenderLeftNav()
                },
                tooltip: _T('Remove from Favorites')
              },
            ]
          }

          return config
        })
      },
      isAllowed: () => {
        const { use_user_preferences, load_nav_extensions } = stateRef.current.fxVars
        return Boolean(use_user_preferences && load_nav_extensions)
      },
      emptyState: NoFavoritesPlaceholder,
    }
  }]
} as ExtensionsConfig//<SparkyDynamicBottomLeftNavConfig>

export default favBottomNav
